<div
    *ngIf="showAlert"
    class="alert-bar-wrapper"
    [ngClass]="{ 'bar-border': alertData?.classes }"
    [ngStyle]="{
        'background-color': alertData.background_color,
        height: alertData.height_percent + 'vh',
    }"
    (click)="hasClickedBanner()"
>
    <div class="container {{ alertData?.classes }}">
        <div class="alert-bar" [ngClass]="{ 'flex-column': alertData?.title }">
            <div *ngIf="alertData?.title" class="message d-block title">
                <h3>{{ alertData?.title }}</h3>
            </div>
            <!--            TODO: rework alert bat for iframe-->
            <h3
                *ngIf="alertData?.header_text"
                [innerHTML]="alertData.header_text | bypassSecurity: 'html'"
                class="header-text"
                [ngStyle]="{ color: alertData.header_text_color }"
            ></h3>
            <div
                *ngIf="alertData.text"
                [innerHTML]="alertData.text | bypassSecurity: 'html'"
                class="message d-block text"
                [ngStyle]="{ color: alertData.text_color }"
            >
                <a
                    [ngStyle]="{ color: alertData.text_color }"
                    [href]="alertData.link"
                    [target]="alertData?.link_target"
                    *ngIf="alertData?.classes"
                >
                    {{ alertData.call_to_action }}
                    <app-icon [type]="'Arrow-right'"></app-icon>
                </a>
            </div>
            <div
                *ngIf="alertData.link && alertData.call_to_action && !alertData?.classes"
                class="link"
            >
                <button
                    class="call-to-action-button"
                    [ngStyle]="{ 'background-color': alertData.call_to_action_background }"
                >
                    <a
                        [ngStyle]="{ color: alertData.call_to_action_color }"
                        (click)="hasClickedBanner()"
                    >
                        {{ alertData.call_to_action }}
                    </a>
                </button>
            </div>
            <div class="close-alert" (click)="close()">
                <app-icon [type]="'ThinCross'" *ngIf="!alertData?.classes"></app-icon>
                <app-icon [type]="'ThinCross'" *ngIf="alertData?.classes"></app-icon>
            </div>
        </div>
    </div>
</div>
